import { CreatePlacedItemBackLog } from "../../Game/BackSystems.js";
import { onStartOverButtonClicked } from "../../Game/ButtonClickHandlers/onStartOverButtonClicked.js";
import { FirstTreeClick } from "../../Game/TweensFile.js";

export function TreeClickHandler()
{
    const Scene = this.scene;

    if(!Scene.ActiveTree)
    {
        FirstTreeClick(Scene);
        //console.log("Not Active")
        TreePlaceSwitch(Scene,this);
    }
    else if(this.frame.name != Scene.ActiveTree.frame.name)
    {
        // Scene.ActiveTree.getData('Stroke').destroy();
        // Scene.ActiveTree.destroy();
        // Scene.HitBoxTree.destroy();
        ////console.log(this.frame.name.replace("BG","Strk"));

        if(Scene.BackLog[0])
        {
            onStartOverButtonClicked(Scene,true,this);
        }
        else
        {
            Scene.AudioChan.Chan3.play('select_tree');

            //let OldTree = {PreviousFrameName: Scene.ActiveTree.frame.name,TintBG: TintReturn(Scene.ActiveTree.tintTopRight)};
            //ldTree.TintStrk = TintReturn(Scene.ActiveTree.getData('Stroke').tintTopRight);
            let OldTree = {PreviousFrameName: Scene.ActiveTree.frame.name,TintBG: Scene.ActiveTree.tintTopRight};
            OldTree.TintStrk = Scene.ActiveTree.getData('Stroke').tintTopRight;

            Scene.ActiveTree.getData('Stroke').setFrame(this.frame.name.replace("BG","Strk"));
            Scene.ActiveTree.setFrame(this.frame.name);
            Scene.HitBoxTree.setFrame(this.frame.name);

            switch(this.frame.name)
            {
                case "Tree_SlimBG":
                    Scene.ActiveTree.getData('Stroke').y = 390;
                    break;
                case "Tree_PntyBG":
                    Scene.ActiveTree.getData('Stroke').y = 391;
                    break;
                case "Tree_FlufBG":
                    Scene.ActiveTree.getData('Stroke').y = 390;
                    break;
                default :
                    break;
            }

            if(this.tintTopRight != Scene.ActiveTree.tintTopRight)
            {
                SetTreeTint(Scene,this); 
            }
            //console.log("Active and no match")
        }

        
    }
    else if(this.frame.name === Scene.ActiveTree.frame.name && this.tintTopRight != Scene.ActiveTree.tintTopRight)
    {
        Scene.AudioChan.Chan5.play('click_in_game');
        //SetTreeTint(Scene,this);
        Scene.ActiveTree.setTint(this.tintTopRight);
        Scene.ActiveTree.getData('Stroke').setTint(this.treeStroke.tintTopRight);
    }
}

function TreePlaceSwitch(Scene,ClickedTree)
{
    var TreeBG;
    var TreeStroke;
    const Name = ClickedTree.frame.name;
    const DepthList = Scene.DepthList;

    Scene.AudioChan.Chan2.play('select_tree');

    switch(Name)
    {
        case "Tree_SlimBG":
            TreeBG = Scene.addImage(703,390,Name);
            TreeStroke = Scene.addImage(703,390,'Tree_SlimStrk');
            break;
        case "Tree_PntyBG":
            TreeBG = Scene.addImage(703,390,Name);
            TreeStroke = Scene.addImage(703,391,'Tree_PntyStrk');
            break;
        case "Tree_FlufBG":
            TreeBG = Scene.addImage(703,390,Name);
            TreeStroke = Scene.addImage(703,390,'Tree_FlufStrk');
            break;
        default :
            break;
    }

    TreeBG.setDepth(DepthList.Tree);
    TreeStroke.setDepth(DepthList.TreeDetail);

    TreeBG.setData({Stroke: TreeStroke});

    Scene.ActiveTree = TreeBG;
    Scene.ActiveTree.setData({Stroke: TreeStroke,AssetType: "Tree"});

    // Scene.ActiveTree.setInteractive(Scene.input.makePixelPerfect());
    // Scene.ActiveTree.input.dropZone = true;

    Scene.HitBoxTree = Scene.addImage(Scene.ActiveTree.x,Scene.ActiveTree.y,Scene.ActiveTree.frame.name);
    //Scene.HitBoxTree = Scene.addImage(0,0,Scene.ActiveTree.frame.name);
    Scene.HitBoxTree.setDepth(DepthList.HitBoxTree);
    Scene.HitBoxTree.setInteractive(Scene.input.makePixelPerfect());
    Scene.HitBoxTree.input.alwaysEnabled = true;
    Scene.HitBoxTree.input.dropZone = true;
    Scene.HitBoxTree.setAlpha(0);

    //console.log(Scene.ActiveTree.input);

    SetTreeTint(Scene, ClickedTree);
}

export function SetTreeTint(Scene,ClickedTree)
{
    const TreeStroke = Scene.ActiveTree.getData('Stroke');
    const TintToBe = ClickedTree.tintTopRight;

    Scene.ActiveTree.setTint(ClickedTree.tintTopRight);
    Scene.ActiveTree.getData('Stroke').setTint(ClickedTree.treeStroke.tintTopRight);
}


